/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { AppLogo } from "@advapacs/common";
import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import ReportIconActive from "../assets/icons/report-filled.svg";
import AccActive from "../assets/icons/account-circle-filled.svg";
import AccIcon from "../assets/icons/acc-circle.svg";
import ReportIcon from "../assets/icons/report-outlined.svg";

export const Sidebar: FC = () => {
  const { pathname } = useLocation();
  return (
    <div className="sidebar sidebar-portal sidebar-light sidebar-main sidebar-expand-md border-right-none">
      <div className="sidebar-content sidebar-section secondary-sidebar secondary-sidebar-portal">
        <div className="card-sidebar-mobile">
          <ul className="nav nav-sidebar portal-sidebar">
            <li className="nav-item d-flex align-items-center m-lr-xs">
              <Link
                className={`nav-link d-flex flex-1 align-items-center b-r-md ${
                  window.location.href.includes("Studies") ||
                  pathname === "/Exams"
                    ? "active exam-link"
                    : ""
                }`}
                to="/Exams"
              >
                <img
                  src={
                    window.location.href.includes("Exams") ||
                    pathname === "/Exams"
                      ? ReportIconActive
                      : ReportIcon
                  }
                  alt="Report Sidebar Icon"
                  className="m-r-xs"
                />
                <span className="font-weight-600">Exams</span>
              </Link>
            </li>

            <li className="nav-item d-flex align-items-center m-lr-xs">
              <Link
                className={`nav-link d-flex flex-1 align-items-center  b-r-md ${
                  window.location.href.includes("MyAccount") ||
                  pathname === "/MyAccount"
                    ? "active exam-link"
                    : ""
                }`}
                to="/MyAccount"
              >
                <img
                  src={
                    window.location.href.includes("MyAccount") ||
                    pathname === "/MyAccount"
                      ? AccActive
                      : AccIcon
                  }
                  alt="Report Sidebar Icon"
                  className="m-r-xs"
                />
                <span className="font-weight-600">My Account</span>
              </Link>
            </li>
          </ul>
        </div>

        <div className="w-100 navbar-text foot-position-pp">
          <div className="w-100 text-center p-t-xs">
            <AppLogo.LogoLong />
          </div>
          <p className=" w-100 text-center m-t-none text-label m-b-none pt-2">
            <p className="m-b-none">
              {" "}
              © {new Date().getFullYear()} AdvaPACS by{" "}
              <a href="https://adva.health" target="_blank">
                AdvaHealth Solutions
              </a>
            </p>
          </p>
        </div>
      </div>
    </div>
  );
};
